module.exports = __webpack_public_path__ + "img/crm_case4.1eb86eaa.png";